module.exports = __webpack_public_path__ + "media/img/tomedo-list-style-image-fb10eefcfc7c00251a242d93e2c4c2b2.svg";